import * as $ from 'jquery';
import lozad from 'lozad';

import '../scss/style.scss';
import './components/marquee'
import './components/popup-forms'
import './components/inputmask'
import './components/common'
import './components/fancybox'

//Lazyload
const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();

$(function () {
    initScripts();
});

function initScripts() {
    function showLinkPreloader(currLink) {
        $(currLink).css('pointer-events', 'none');
        $(currLink).find('.offer-button span').addClass('hide');
        $(currLink).find('.lds-ellipsis').removeClass('hide');
    }

    function hideLinkPreloader(currLink) {
        $(currLink).css('pointer-events', 'auto');
        $(currLink).find('.offer-button span').removeClass('hide');
        $(currLink).find('.lds-ellipsis').addClass('hide');
    }

    function getLink() {
        $(".tpl-offer__wrapper").click(function (event) {
            event.preventDefault();

            const offerId = $(this).data("offer-id");
            const currentDomain = window.location.origin;
            const apiUrl = `${currentDomain}/api/click/send?offerId=${offerId}`;
            const currLink = this;
            showLinkPreloader(currLink);

            $.ajax({
                url: apiUrl,
                method: "GET",
                timeout: 30000,
                success: function (response) {
                    if (response.status === "success" && response.link) {
                        hideLinkPreloader(currLink);

                        // Обрабатываем ссылку в зависимости от браузера
                        const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
                        const isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
                        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

                        if (isChrome || isFirefox) {
                            // Открываем ссылку в новой вкладке
                            window.open(response.link, "_blank");
                        } else if (isIOS) {
                            // Для iOS используем window.open с задержкой
                            setTimeout(() => {
                                window.open(response.link, "_blank");
                            }, 100);
                        } else if (isSafari) {
                            // Для Safari создаем элемент ссылки и запускаем его кликом
                            const a = document.createElement("a");
                            a.setAttribute("href", response.link);
                            a.setAttribute("target", "_blank");
                            a.click();
                            a.remove();
                        } else {
                            // Для других браузеров открываем ссылку в новой вкладке
                            window.open(response.link, "_blank");
                        }
                    } else {
                        hideLinkPreloader(currLink);
                        console.error("Error: invalid response");
                    }
                },
                error: function (error) {
                    hideLinkPreloader(currLink);
                    console.error(error);
                },
            });
        });
    }

    getLink();

}

